import { memo } from 'react'
import { InfoCardRow } from '../info-card-row/InfoCardRow'
import './InfoCard.scss'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const InfoCard = memo(({ infoConfig, className = '' }) => (
  <div className={`info-card-main-wrapper${className ? ` ${className}` : ''}`}>
    <div className='info-card-text info-card-title'>{infoConfig.title}</div>
    {/*
     // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
    {infoConfig.body.map(({ key, value }, idx) => (
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      <InfoCardRow key={key} keyValue={key} value={value} isTheLast={infoConfig.body.length - 1 === idx} />
    ))}
  </div>
))
